import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { isUseCase } from '@/lib/utils'

export const defaultDateRange = {
  startDate: dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD'),
  endDate: dayjs().format('YYYY-MM-DD'),
}

export const SearchSchema = z.object({
  selectedUnit: z.string().optional(),
  sites: z.array(z.string()).optional(),
  buildings: z.array(z.string()).optional(),
  floors: z.array(z.string()).optional(),
  locationSearch: z.string().optional(),
  filterBy: z.enum(['site', 'building', 'floor', 'unit']).optional(),
  // Pas de défaut Zod : le mode effectif est calculé côté composant (diagram si au moins une CTA a un
  // synoptic, sinon card), car cela dépend des données chargées et non de l'URL.
  viewMode: z.enum(['diagram', 'card', 'table']).optional(),
})

export type Search = z.infer<typeof SearchSchema>

export type ViewMode = 'diagram' | 'card' | 'table'

export function useSearch() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  const setSearch = (search: Search) => {
    void navigate({
      search,
      replace: true,
    })
  }

  return { search, setSearch }
}

export const Route = createFileRoute('/_dashboard/energy-monitoring/air-handling-unit/')({
  validateSearch: SearchSchema,
  async beforeLoad() {
    if (!isUseCase(UseCase.ENERGY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  pendingComponent: PendingComponent,
})
